<template>
  <el-form
    ref="form"
    :model="form">
    <el-row
        type="flex"
        class="gj-picker">
      <div class="gj-picker__editor">
        <el-tabs :value="'first'">
          <el-tab-pane label="建议" name="first">
            <el-row type="flex" justify="flex-end" :gutter="20">
              <el-col :span="6">
                <gj-select
                    v-model="filter.biddingType"
                    :options="biddingOption"
                    width="100%"
                    :clearable="false">
                </gj-select>
              </el-col>
              <el-col :span="6">
                <gj-input
                  v-show="filter.biddingType == 1"
                  v-model="filter.custom"
                  v-number.price
                  maxlength="12"
                  width="100%"
                  placeholder="">
                  <template #prepend>{{currencySymbol}}</template>
                </gj-input>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="匹配条件"
                  style="margin-bottom: 0;">
                <el-checkbox-group
                    v-model="form.matchTypes">
                  <el-checkbox
                      v-for="item in matchTypeOption"
                      :key="item.id"
                      :label="item.id">
                    {{item.text}}
                  </el-checkbox>
                </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <gj-table
                :index="false"
                :show-pagination="false"
                :adapt-height="false"
                :height="363"
                :loading="suggestKeywordLoading"
                :data="suggestKeywords"
                :columns="columns0"
                class="suggest-table">
              <template v-slot:header:op>
                <gj-button
                    type="text"
                    @click="addAllItem()"
                >添加全部</gj-button>
              </template>
              <template v-slot:keywordText="{ row }">
                <div>{{ row.keywordText | defaultShow}}</div>
                <div class="color999" v-if="row.localizeKeywordText">{{row.localizeKeywordText | defaultShow}}</div>
              </template>
              <template v-slot:matchType="{ row }">
                <div v-for="(item, i) in row.recommendedBids"
                     v-show="form.matchTypes.includes(item.matchType)"
                     :key="i"
                     style="line-height: 22px;">
                  {{ item.matchType | optionText(matchTypeOption) }}
                </div>
              </template>
              <template v-slot:recommendedBid="{ row }">
                <div 
                  v-for="(item, i) in row.recommendedBids"
                  v-show="form.matchTypes.includes(item.matchType)"
                  :key="i"
                  style="line-height: 22px;">
                  <span v-if="filter.biddingType == 0">{{ item.recommendedBid | defaultShow(currencySymbol) }}</span>
                  <span v-else>{{ item.rangeStart | defaultShow(currencySymbol) }} - {{ item.rangeEnd | defaultShow(currencySymbol) }}</span>
                </div>
              </template>
              <template v-slot:op="{ row }">
                <div v-for="(item, i) in row.recommendedBids"
                     :key="i"
                     v-show="form.matchTypes.includes(item.matchType)">
                  <gj-button
                      type="text"
                      :disabled="item.isAddPage || item.isAdd"
                      style="padding: 0; line-height: 21px;"
                      @click="addItem(item)"
                  >添加</gj-button>
                </div>
              </template>
            </gj-table>
          </el-tab-pane>
          <el-tab-pane label="输入列表" name="second">
            <div v-loading="inputLoading">
              <el-row :gutter="20" type="flex" justify="flex-end">
                <el-col :span="6">
                  <gj-select
                      v-model="filter.biddingType"
                      :options="biddingOption"
                      width="100%"
                      :clearable="false">
                  </gj-select>
                </el-col>
                <el-col :span="6">
                  <gj-input
                    v-show="filter.biddingType == 1"
                    v-model="filter.custom"
                    v-number.price
                    maxlength="12"
                    width="100%"
                    placeholder="">
                    <template #prepend>{{currencySymbol}}</template>
                  </gj-input>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="匹配条件"
                    style="margin-bottom: 0;">
                  <el-checkbox-group
                      v-model="form.matchTypes">
                    <el-checkbox
                        v-for="item in matchTypeOption"
                        :key="item.id"
                        :label="item.id">
                      {{item.text}}
                    </el-checkbox>
                  </el-checkbox-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <div style="margin-bottom: 10px;">
                <gj-textarea
                    v-model="keywordText"
                    :styles="{ height: '292px', fontSize: '12px', 'border-color': this.errorKeyword ? '#F56C6C' : '' }"
                    placeholder="请选择关键词，一行一个，回车换行">
                </gj-textarea>
              </div>
              <el-row
                  type="flex"
                  align="middle"
                  justify="space-between"
                  class="gj-picker__editor--footer">
                <span :class="{red: errorKeyword}">关键词不得包含特殊字符，如@、#、*和$等</span>
                <!---->
                <gj-button
                    type="primary"
                    @click="addKeyword"
                    :disabled="!isMeaningful(keywordText)"
                >添加</gj-button>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="上传" name="upload">
            <div class="upload-cell">请使用模版，确保您上传的信息准确无误</div>
            <div class="upload-cell">仅支持XLSX格式！</div>
            <div class="upload-cell upload-fn">
              <gj-upload-attach :file-list="uploadAttFiles" :beforeUpload="beforeUpload">
                <gj-button type="primary" :loading="uploadLoading">上传</gj-button>
              </gj-upload-attach>
              <gj-button class="download" type="text" :loading="downloadLoading" @click="download()">下载模板</gj-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="gj-picker__table">
        <div class="gj-picker__table--title">已添加 {{form.items.length}} 个{{title}}<span class="gj-picker__table--tip">（最多可添加1000个，会过滤重复的{{title}}）</span></div>
        <gj-table
            :index="false"
            :show-pagination="false"
            :adapt-height="false"
            :height="412"
            :data="form.items"
            :columns="columns">
          <template v-slot:header:op>
            <gj-button
                type="text"
                @click="deleteAllItem()"
            >全部移除</gj-button>
          </template>
          <template v-slot:keywordText="{ row }">
            <div>{{ row.keywordText | defaultShow}}</div>
            <div class="color999" v-if="row.localizeKeywordText">{{row.localizeKeywordText | defaultShow}}</div>
          </template>
          <template v-slot:header:application>
            <gj-button type="text" @click="applicationFn('all')">全部应用</gj-button>
          </template>
          <template v-slot:recommendedBid="{ row }">
            <gj-button type="text" @click="applicationFn('item', row)">{{ row.recommendedBid  | defaultShow(currencySymbol) }}</gj-button>
          </template>
          <template v-slot:application="{ row }">
            {{ row.rangeStart ? currencySymbol +  row.rangeStart : ""}}
               - 
            {{ row.rangeEnd ? currencySymbol +  row.rangeEnd : ""}}
          </template>
          <template v-slot:bid="{ index }">
            <el-form-item
                :prop="`items.${index}.bid`"
                :rules="[
                  { required: true, message: '请输入竞价', trigger: ['blur', 'change'] },
                  $gjMinRule(0.02, '应大于等于0.02'),
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].bid"
                  size="mini"
                  width="110px"
                  v-number.price>
                <template #prepend>
                  <span class="dark-input">{{currencySymbol}}</span>
                </template>
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:op="{ index, row }">
            <gj-button
                type="text"
                @click="deleteItem(index, row)"
            >移除</gj-button>
          </template>
        </gj-table>
      </div>
    </el-row>
    <div class="gj-picker-solid"></div>
  </el-form>
</template>

<script>
  import { isMeaningful, unique } from "@/utils/common";
  import { exportFile } from "@/api/common";
  import { AdKeywordEnum } from "modules/ad/common/enum";
  import { formMixin, formRuleMixin, isMeaningfulMixin } from "@/minxins";
  import { importKeywords, suggestedBid } from "@/api/ad"
  import {adKeywordTranslation} from "../../../../../common/mixin";
  export default {
    name: "app-keywordText-picker",
    mixins: [isMeaningfulMixin, formMixin, formRuleMixin, adKeywordTranslation],
    props: {
      title: {
        required: true,
      },
      currencySymbol: {
        required: true,
        default: null
      },
      marketId: {
        required: true,
        default: null
      },
      matchTypeOption: {
        required: true
      },
      params: { // 亚马逊竞价参数
        default: ()=> ({})
      },
      bid:null
    },
    created() {
      this.columns[0].header = this.title;
    },
    data() {
      return {
        filter: { // 关键词建议搜索条件
          custom: 1, // 自定义竞价
          biddingType: 0, // 竞价类型
          matchTypes: 0 // 匹配条件
        },
        suggestKeywords: [], // 构建后的关键词数据
        suggestedBidList: [],
        suggestKeywordLoading: false,
        inputLoading: false, // 输入关键词处的loading
        downloadLoading: false, // 下载loading
        uploadLoading: false,
        AdKeywordEnum: AdKeywordEnum,
        keywordText: null,
        uploadAttFiles: [], // 上传
        biddingOption: [
          {id: 0, text: '建议竞价'},
          {id: 1, text: '自定义竞价'},
        ],
        columns0: [
          {id: 'keywordText', header: '关键词', field: 'slot:keywordText', minWidth: '170px'},
          {id: 'matchType', header: '匹配类型', field: 'slot:matchType', minWidth: '100px'},
          {id: 'recommendedBid', header: '建议竞价', field: 'slot:recommendedBid', minWidth: '130px'},
          {id: 'op', header: 'slot:op', field: 'slot:op', minWidth: '70px'},
        ],
        columns: [
          {id: 'keywordText', header: '关键词', field: 'slot:keywordText', minWidth: '100px'},
          {id: 'matchType', header: '匹配类型', field: 'option:matchType', options: () => this.matchTypeOption, minWidth: '60px'},
          {id: 'recommendedBid', header: '建议竞价', field: 'slot:recommendedBid', minWidth: '60px', align: 'right'},
          {id: 'application', header: 'slot:application', field: 'slot:application', minWidth: '100px'},
          {id: 'bidding', header: '竞价', field: 'slot:bid', minWidth: '110px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', minWidth: '60px'},
        ],
        errorKeyword: false,
        keywordStyle: {height: '292px'}
      }
    },
    watch: {
      keywordText(val) {
        this.errorKeyword = !/^[^!#%<>@*$]*$/.test(val);
      },
      suggestedBidList(val) {
        this.setSuggestKeywords()
      },
      "form.matchTypes"(val) {
        this.setSuggestKeywords()
      },
      bid:{
        handler(val){
          this.filter.custom = val
        },
        immediate: true
      }
    },
    methods: {
      // 品牌广告-建议关键词及其竞价 (父组件ref有用到)
      async suggestedBid(params) {
        let paramsMap = {
          marketId: this.marketId
        }
        Object.assign(paramsMap, params)
        this.suggestKeywordLoading = true
        this.suggestedBidList = []
        try {
          let { data } = await suggestedBid(paramsMap) || []
          this.suggestedBidList = [...data]
          // 查询关键词翻译 （mixin--adKeywordTranslation 中的方法）
          // 需从混入或者prop中获取 marketId
          if(this.suggestedBidList.length>0){
            await this.getKeywordsInterpret(this.suggestedBidList)
          }
        } finally {
          this.suggestKeywordLoading = false
        }
      },
      // 组件内获取数据
      async suggestedBidInput(params) {
        let paramsMap = {
          marketId: this.marketId
        }
        let keywords = []
        Object.assign(paramsMap, this.params, params)
        this.inputLoading = true
        keywords = []
        try {
          let { data } = await suggestedBid(paramsMap) || []
          keywords.push(...data)
          // 查询关键词翻译 （mixin--adKeywordTranslation 中的方法）
          // 需从混入或者prop中获取 marketId
          await this.getKeywordsInterpret(keywords)
        } finally {
          this.inputLoading = false
        }
        return keywords
      },
      // 应用
      applicationFn(type, row) {
        const opt = {
          all:()=> {
            this.form.items.forEach(item => {
              item.bid = item.recommendedBid
            })
          },
          item: () => {
            row.bid = row.recommendedBid
          },
        }
        opt[type]()
      },
      // 上传前处理
      beforeUpload(file) {
        file && this.upload(file)
        return false
      },
      // 上传
      async upload(file) {
        this.uploadLoading = true
        let formData = new FormData();
        formData.append('file', file);
        formData.append('marketId', this.marketId);
        let { data = [] } = await importKeywords(formData)
        let keywords = []
        // 查询关键词翻译 （mixin--adKeywordTranslation 中的方法）
        // 需从混入或者prop中获取 marketId
        if(data.success && data.success.length>0){
          await this.getKeywordsInterpret(data.success)
        }
        data.success.forEach(item => {
          keywords.push({
            keywordText: item.keywordText,
            localizeKeywordText: item.localizeKeywordText,
            matchTypeText: this.matchTypeOption.find(e => e.id === item.matchType).text,
            matchType: item.matchType,
            recommendedBid: item.recommendedBid,
            rangeStart: item.rangeStart,
            rangeEnd: item.rangeEnd,
            bid: item.bid,
          })
        })
        this.uploadLoading = false
        this.addKeywords(keywords);
      },
      // 下载
      download() {
        this.downloadLoading = true
        exportFile('/ads/adsSbKeywords/getImportKeywordsTemplate').finally(() => { this.downloadLoading = false })
      },
      // 构造关键词数据
      setSuggestKeywords() {
        this.suggestKeywords = []
        let suggestKeywords = []
        let suggestedBidList = []
        suggestedBidList = this.suggestedBidList.filter(e => this.form.matchTypes.includes(e.matchType))
        let keywordGroup = this._.groupBy(suggestedBidList, 'keywordText')
        for (const key in keywordGroup) {
          suggestKeywords.push({
            keywordText: key,
            localizeKeywordText: keywordGroup[key][0].localizeKeywordText||'',
            recommendedBids: keywordGroup[key]
          })
        }
        this.suggestKeywords = suggestKeywords
      },
      // 输入列表新增
      addKeyword() {
        let keywords = [];
        this.keywordText.split('\n')
          .map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, ''))
          .filter(item => isMeaningful(item) && !/\n+/.test(item))
          .forEach(item => {
            keywords.push({
              keywordText: item,
              matchTypes: this.form.matchTypes
            })
          });
        this.suggestedBidInput({keywords}).then(res => {
          res.forEach(row => {
            this.addItem(row)
          });
        })
        this.keywordText = null;
        this.refreshBtnDisable();
      },
      // 建议-添加全部
      addAllItem() {
        this.addKeywords(this.suggestKeywords.map(e => {
          return this.mapTo(e.keywordText, e.localizeKeywordText, e.recommendedBids);
        }).reduce((e1, e2) => e1.concat(e2), []));
      },
      mapTo(keywordText, localizeKeywordText, recommendedBids) {
        return recommendedBids.map(e => ({
          keywordText,
          localizeKeywordText,
          matchTypeText: this.matchTypeOption.find(e1 => e1.id === e.matchType).text,
          matchType: e.matchType,
          recommendedBid: e.recommendedBid,
          rangeStart: e.rangeStart,
          rangeEnd: e.rangeEnd,
          bid: this.filter.biddingType == 1 ? this.filter.custom : null
        }));
      },
      // 建议-添加
      addItem( row ) {
        this.addKeywords([{
          keywordText: row.keywordText,
          localizeKeywordText: row.localizeKeywordText,
          matchTypeText: this.matchTypeOption.find(e => e.id === row.matchType).text,
          matchType: row.matchType,
          recommendedBid: row.recommendedBid,
          rangeStart: row.rangeStart,
          rangeEnd: row.rangeEnd,
          bid: this.filter.biddingType == 1 ? this.filter.custom : null,
        }]);
      },
      // 全部移除
      deleteAllItem() {
        this.form.items = [];
        this.refreshBtnDisable();
      },
      // 移除
      deleteItem(index) {
        this.form.items.splice(index, 1);
        this.refreshBtnDisable();
      },
      // 添加关键词 
      addKeywords(keywords) {
        this.form.items = unique(this.form.items.concat(keywords), ['keywordText', 'matchType']);
        this.refreshBtnDisable();
      },
      refreshBtnDisable() {
        this.suggestKeywords
          .map(e => {
            e.recommendedBids.forEach(e1 => e1.keywordText = e.keywordText);
            return e.recommendedBids;
          })
          .reduce((e1, e2) => e1.concat(e2), [])
          .forEach(e1 => {
            if (this.form.items.some(e2 => `${e1.keywordText}_${e1.matchType}` === `${e2.keywordText}_${e2.matchType}`)) {
              this.$set(e1, 'isAddPage', true);
            } else {
              this.$set(e1, 'isAddPage', false);
            }
          });
      },
      formValidate() {
        let formValid = this.form.items.length > 0;
        if (!formValid) {
          this.$gjMessage.error('请添加关键词');
          return false;
        }
        if (this.form.items.length > 1000) {
          this.$gjMessage.error('最多可添加1000个关键词');
          return false;
        }
        this.$refs.form.validate((valid) => {
          formValid = formValid && valid;
        });
        return formValid;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "picker";
  .suggest-table {
    margin: 0 -12px;
    border-top: 1px solid #e8eaec;
  }
  .gj-picker__editor {
    &::before {
      content: "关键词";
    }
    &::after {
      content: "*";
      color: #F56C6C;
      position: absolute;
      font-size: 12px;
      top: 0;
      left: -63px;
    }
  }
  .gj-picker {
     height: 445px;
  }
  .gj-picker__editor{
    height: 443px !important;
  }
  .gj-picker {
    margin-left: 66px;
  }
  .default-bid {
    margin-bottom: 0;
    position: absolute;
    top: 0;
    left: 280px;
  }
  /deep/ .el-tabs__header {
    margin-bottom: 10px !important;
  }
  .download {
    padding-left: 6px;
  }
  /deep/ .el-radio__label,
  /deep/ .el-checkbox__label {
    font-size: 12px;
  }
  /deep/.el-checkbox {
    margin-right: 15px;
  }
  /deep/.vxe-table--border-line{
    border: none !important;
  }
  .gj-picker__table--title{
    height: 29px !important;
    line-height: 29px !important;
  }
  .download{
    padding: 0;
    margin-left: 12px;
  }
  .upload-fn{
    align-items: center !important;
  }
  /deep/ .el-tabs__content{
    padding:  2px 12px !important;
  }
  /deep/ .el-input__suffix{
    // display: inline-block;
    // width: 24px;
    // height: 26px;
    // line-height: 26px;
    // background: #EEEFF0;
    // right: 1px;
    // top: 3px
  }
</style>
